
import {Component, Watch, Prop} from "vue-property-decorator";
import ATable from '@common/table/components/table-list/ATable.vue';
import {TicketService} from "@share/common/services/ticket/TicketService";
import ATableRow from "@share/ticketSystem/components/table-list/TableRow.vue";
import {TicketType} from "@share/ticketSystem/enums/TicketTypes";
import {RouteNamesEnum} from "@service/router/RouteNamesEnum";
import {TicketTableParams} from "../data";
import i18n from "@service/locale/i18";
import { TicketTableHelper } from "@share/ticketSystem/helpers/TicketTableHelper";

@Component({
    components: {
        ATableRow
    }
})
export default class Table extends ATable {
    @Prop({required: true}) params: TicketTableParams;
    @Prop({required: true}) declare tableHelper: TicketTableHelper;

    ticketsType: TicketType;
    ticketService: TicketService;
    uniqueTableSelector = 'tickets-table';

    async resetTable() {
        if (this.params.ticketsType) {
            this.setTicketsTypeFromParams();
        }
        this.tableHelper.page = 1;
        this.tableHelper.resetSorting();
        this.isFilterReversed = true;
        this.currentFilter = this.tableHelper.filterOrder;
        await this.setFilters();
        await this.initializeData();
        this.showIconFilterSet();
    }

    @Watch('ticketType')
    watchTicketType() {
        this.resetTable();
    }

    @Watch('onlyOwn')
    watchOnlyOwn() {
        this.resetTable();
    }

    // имя роута, на который будет осуществляться переход при нажатии на ячейку с названием тикета
    routeName(): string {
        if (this.params.ticketsType === TicketType.idea) {
            return RouteNamesEnum.ticketSystemIdeaView;
        }
        return RouteNamesEnum.ticketSystemProblemView;

    }

    lsKey() {
        return this.backend + this.$store.getters.userId + '_' + this.id + '-filter_' + this.ticketsType;
    }

    setTicketsType() {
        this.tableHelper.ticketType = this.ticketsType;
    }

    setTicketsTypeFromParams() {
        this.ticketsType = this.params.ticketsType;
    }

    getPlaceholderText() {
        return i18n.t('tickets.filters.search');
    }

    doBeforeCreate(): void {
        if (this.params.ticketsType) {
            this.setTicketsTypeFromParams();
        }
        if (this.params.ticketService) {
            this.ticketService = this.params.ticketService;
        }
    }

    doBeforeInitialize(): void {
        this.setTicketsType();
    }

    doBeforeSetFilters(): void {
        this.setTicketsType();
    }

    get ticketType() {
        return this.params.ticketsType
    }

    get onlyOwn() {
        return this.params.onlyOwn
    }
}
